import request from '@/utils/server'

  export function getLogin(data) {
    return request({
      url: '/user/pc/login',    
      method: 'POST',
      data:data
    })
  }
